<script>
import AdminLayout from '@layouts/admin-main'
import AccountBalanceLogList from '@components/admin/account-balance-log-list'
import AccountNav from '@components/admin/account-nav'

export default {
  page: {
    title: 'Admin::AccountBalanceLogList',
    meta: [{ name: 'description', content: 'Admin::AccountBalanceLogList' }],
  },
  components: { AdminLayout, AccountBalanceLogList, AccountNav },
}
</script>

<template>
  <AdminLayout>
    <AccountNav></AccountNav>
    <AccountBalanceLogList></AccountBalanceLogList>
  </AdminLayout>
</template>
